import React, { useState, useEffect } from 'react';
import './LandscapeGuide.css'; // 确保CSS文件已存在或内联样式
import { isWeChat, isIOS } from '../../utils/browserUtils'

const LandscapeGuide = ({ isMobile }) => {

  const [isVisible, setIsVisible] = useState(false);

  // 检查是否已经关闭过，避免重复显示
  useEffect(() => {
    if (!isMobile) return;

    setIsVisible(true);
    document.body.style.overflow = 'hidden'; // 禁止滚动
  }, []);

  useEffect(() => { 
    if (!isMobile) {
        setIsVisible(false);
    }
  }, [isMobile]);

  // 清理副作用：组件卸载时恢复滚动
  useEffect(() => {
    return () => {
      if (isVisible) {
        document.body.style.overflow = '';
      }
    };
  }, [isVisible]);

  const handleClose = (e) => {

    // 组织a标签默认跳转行为
    e.preventDefault();

    setIsVisible(false);
    document.body.style.overflow = ''; // 恢复页面滚动
  };

  // 如果不是移动端或已关闭，则不渲染
  if (!isMobile || !isVisible) {
    return null;
  }

  return (
    <div className="guide-wrap">
      {/* 风格1：横屏引导步骤(微信体系) */}
      {(isWeChat() && !isIOS()) && (
        <div className="guide-step-content">
            <img src="/images/guide/top-arr.png" className="guide-top-arr" alt="top arrow" />
            
            <div className="guide-step guide-step1">
            <img src="/images/guide/step1.png" alt="步骤1" />
            </div>

            <div className="guide-step guide-step2">
            <img src="/images/guide/step2.png" alt="步骤2" />
            </div>

            <div className="guide-step guide-step3">
            <img src="/images/guide/step3.png" alt="步骤3" />
            </div>

            <a href="#!" className="guide-close-btn" onClick={handleClose}>
            我要竖屏观看
            </a>
        </div>
      )}

      {/* 风格2：解锁提示（隐藏） */}
      {!(isWeChat() && !isIOS()) && (
        <div className="guide-step-content style2">
            <div className="guide-step guide-unlock">
            <img src="/images/guide/unlock.png" alt="解锁提示" />
            <a href="#!" className="guide-close-btn" onClick={handleClose}>
                我要竖屏观看
            </a>
            </div>
        </div>
      )}
    </div>
  );
};

export default LandscapeGuide;